/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

// suggest code improvements for this component
// give the entire code to copy

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RiLockPasswordFill } from 'react-icons/ri';

import { customer_send_password_reset_link, messageClear } from '../store/reducers/authReducer';

import Header from '../components/Header';
import Footer from '../components/Footer';
import SiteBadge from '../components/SiteBadge';
import GetSellerConfig from '../components/GetSellerConfig';

import toast from 'react-hot-toast';
import config from '../config';

const ForgotPassword = () => {
    const dispatch = useDispatch();

    //const { seller } = useSelector(state => state.seller);
    const { loader, errorMessage, successMessage } = useSelector(state => state.auth);
    
    const { 
        seller, sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber,
        sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia
    } = GetSellerConfig();

    // const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
    // const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;

    // const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
    // const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
    // const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
    // const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(customer_send_password_reset_link({
            webSiteOrigin: config.STR_FRONTEND_URL,
            sellerId: sellerId,
            email,
        }));
    };

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
    }, [successMessage, errorMessage, dispatch]);

    if (!seller) return null;

    return (
        <div>
            <Header />
             <main className="flex-1 flex items-center justify-center px-4 py-8"
                style={{ backgroundColor: sellerComponentBackgroundColor }}>
                <div className="w-full max-w-sm">
                    <div  className="bg-white rounded-2xl shadow-xl overflow-hidden"
                        style={{ 
                            borderTop: `4px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                            borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
                            borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                            borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`, 
                        }}>
                        <div className="px-8 pt-8 pb-10">
                            <div className="flex items-center justify-center justify-items-center mb-8 text-left">
                                <div
                                    className="inline-flex items-center justify-center w-14 h-14 rounded-xl mb-0 mr-2">
                                    <SiteBadge  iconType='ForgotPassword' iconSize={42} badgeSize={54} />
                                </div>
                                <div>
                                    <span className='leading-tight text-right font-semibold text-[20px] sm:text-[16px]' 
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        {
                                            <>Forgot My Password<br /><span className='font-bold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                                Let's Get You A New One
                                            </span></>
                                        }
                                    </span>
                                </div>
                            </div>

                            <form onSubmit={handleSubmit}>
                                <div className="flex flex-col gap-1 mb-4" style={{ color: sellerPrimaryColor1 }}>
                                    <label htmlFor="email">Email</label>
                                    <input
                                        id="email"
                                        type="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md"
                                        required
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={loader}
                                    className="flex justify-center items-center gap-2 px-8 w-full py-2 
                                    text-white rounded-md disabled:opacity-60 disabled:cursor-not-allowed transition-opacity"
                                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    <RiLockPasswordFill className="text-[20px]" />
                                    {loader ? 'Sending...' : 'Send Reset Link'}
                                </button>
                            </form>
                            <p className="text-center text-sm mt-4 text-slate-500">
                                Do You Remember your password?{' '}
                                <Link to="/login" className="hover:underline" style={{ color: sellerPrimaryColor1 }}>
                                    Back to Login
                                </Link>
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ForgotPassword;


//my original code
// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { RiLockPasswordFill } from "react-icons/ri";
// import { FaUser, FaUserCheck } from "react-icons/fa";

// import Header from '../components/Header';
// import Footer from '../components/Footer';

// import { customer_send_password_reset_link, messageClear } from '../store/reducers/authReducer';

// import toast from 'react-hot-toast';
// import config from '../config';

// const ForgotPassword = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerDashboardURL = config.STR_DASHBOARD_URL

//     const { seller } = useSelector(state => state.seller)
//     const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);
        
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
//     //console.log('sellerId', sellerId)

//     const navigate = useNavigate();
//     const dispatch = useDispatch();
    
//     const [state, setState] = useState({
//         webSiteOrigin: sellerFrontendURL, email: '', sellerId: seller._id
//     });
    
//     const inputHandle = (e) => {
//         setState({
//             ...state,
//             [e.target.name]: e.target.value
//         });
//         //console.log('state', state)
//     };

//     const customer_send_password_reset_link_local = (e) => {
//         e.preventDefault();
//         dispatch(customer_send_password_reset_link(state));
//     };
 
//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage]);
 
//     return (
//         <div>
//             <Header />
//             <div className='min-w-screen bg-slate-200 flex justify-center items-center' >
//                 <div className='w-[350px] h-[160px] items-center m-8 flex justify-center'>
//                     <div className='bg-white text-[#ffffff] p-4 rounded-md shadow-lg'>
//                         <form onSubmit={customer_send_password_reset_link_local} className=''>
//                             <div className='text-center text-xl font-bold' style={{ color: sellerPrimaryColor1 }}>
//                                 Forgot My Password
//                             </div>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="email">Email</label>
//                                 <input onChange={inputHandle} value={state.email} 
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' 
//                                     type="email" name='email' placeholder='Email' id='email' required />
//                             </div>
//                             <button
//                                 className='flex mb-3 justify-center px-8 w-full py-2 shadow-lg hover:shadow-green-500/40 text-white rounded-md'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <RiLockPasswordFill className='mr-2 text-[20px]' /> Send Reset Link
//                             </button>
//                         </form>
//                     </div>
//                 </div>  
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default ForgotPassword;


